import { render, staticRenderFns } from "./GeneralForm.vue?vue&type=template&id=96b213b0&scoped=true&"
import script from "./GeneralForm.vue?vue&type=script&lang=js&"
export * from "./GeneralForm.vue?vue&type=script&lang=js&"
import style0 from "./GeneralForm.vue?vue&type=style&index=0&id=96b213b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b213b0",
  null
  
)

export default component.exports